<template>
  <div>
    <div class="row">
       <div class="col-md-10">
           
       </div>
       <div class="col-md-2">

       </div>
    </div>
    <div class="col-md-12">
        <h4>Cadastro de Assuntos</h4>
    </div>

    <div class=" card col-md-12" >
       <div class="row">
          <div class="col-md-12" style="margin-top:20px;">
            <base-input type="text"
                 label="Assunto"
                 placeholder="Assunto"
                 v-model="assunto.nome"
                 maxlength="150" >
            </base-input>
          </div>
        </div> 
        <div class="row">
           <div class="col-md-5">
              <div class="checkbox">
                <label>Status</label>
                <switch-button v-model="assunto.status" color="#253DB9" meuid="nada" modulo="assunto" funcao="cadastrar"></switch-button>
                <!--<label><input type="checkbox" v-model="departamento.status"> Status</label>-->
              </div>
           </div>
        </div>
        <div class="row">
            <div class="text-center" style="margin-left:15px;margin-top:20px;margin-bottom:20px;">
                <button type="button" class="btn btn-primary btn-fill float-left" @click.prevent="cadastrar">  
                  Cadastrar
                </button>
                <button class="btn btn-danger" @click="retornar()"  style="margin-left: 8px;">Cancelar</button>
            </div>
        </div> 
    </div>  
    
  </div>
  
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import axios from 'axios';
import store from "src/store.js"
import 'src/controller/sistema/assuntoSecretariaController.js'
import SwitchButton from 'src/components/switch.vue'

export default {
  name: 'departamento',
  components: {
    VueGoodTable,
    SwitchButton
  },
  data(){
    return {
      assunto:{
        nome:null,
        status:false,
      },
      status:null,
    };
  },
  methods: {
      async cadastrar(){
        try {

          if(this.assunto.nome==null){
            alert('O campo de nome do assunto não pode ser vazio!');
            return false   
          }

          if(this.assunto.status == true){
             this.status = 1;
          }else{
             this.status = 0;
          }
         //console.log("nome "+this.assunto.nome+" status "+this.assunto.status);
          let data = await this.$assuntoCadastrar(this.assunto.nome,this.status);
                  
        } catch (e) {
              
        }
      },
      retornar(){
          this.$router.push({name: 'assuntos'} );
      }

  },
  beforeMount() {
    try {
      
    }catch(e){
      
    }    
    
  }
};
</script>



